import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay, switchMap } from 'rxjs/operators';

import { L10nService } from '@nano/core/l10n';
import { Classifier, ClassifierService, CountryGroup } from '@nano/common/classifier';

@Injectable({ providedIn: 'root' })
export class CountryService {
  readonly worldwideCountries$: Observable<Classifier[]>;
  readonly cardIssuingEEACountries$: Observable<Classifier[]>;

  constructor(
    private classifierService: ClassifierService,
    private l10nService: L10nService
  ) {
    this.worldwideCountries$ = this.l10nService.schema$.pipe(
      switchMap(() => this.classifierService.getCountries(CountryGroup.WORLDWIDE)),
      shareReplay({ refCount: false, bufferSize: 1 })
    );
    this.cardIssuingEEACountries$ = this.l10nService.schema$.pipe(
      switchMap(() => this.classifierService.getCountries(CountryGroup.CARD_ISSUING_EEA)),
      shareReplay({ refCount: false, bufferSize: 1 })
    );
  }
}
